import React from "react";
import { DiagnosticProvider } from "userful-chronos-common-store/dist/diagnostics";
import { DiagnosticNotifications } from "./DiagnosticNotifications";

export const DiagnosticContainer = (props) => {
    return (
        <DiagnosticProvider>
            <DiagnosticNotifications />
        </DiagnosticProvider>
    );
};
